import * as React from 'react'
import { Button } from 'primereact/button'
import Icon from 'app/shared/components/Icon'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import {
    getLocalDateTime,
    replaceTextToHtmlTag,
    convertToHtml,
} from 'app/shared/utils/comUtil'

import { bnnList } from 'app/core/models/api/com/com0102'
import DOMPurify from 'dompurify'

/**
 * TODO:
 * 컴퍼넌트에서 외부 타입 참조는 바람직하지 않다.
 * 개발 확정 후 별도로 만들어 넣도록 한다.
 */
export type BannerItem = bnnList
/**
 * 메인/상품몰 베너
 * @returns
 */
const Banner: React.FC<{ items?: BannerItem[] }> = ({ items = [] }) => {
    const sliderRef = React.useRef<Slider | null>(null)
    const [isPlaying, setIsPlaying] = React.useState(true)
    const [currentSlide, setCurrentSlide] = React.useState(0)
    const toggleplay = () => {
        const slider = sliderRef.current
        if (!slider) return
        if (isPlaying) {
            slider.slickPause()
        } else {
            slider.slickPlay()
        }
        setIsPlaying(!isPlaying)
    }

    const parseLink = (item: BannerItem) => {
        let link = {
            href: convertToHtml(item.lurlAdr1Con) ?? '#',
            target: '_self',
            rel: null,
        }
        if (item.linkDcd === '01') return {}
        if (item.linkDcd === '05') {
            const device = globalThis.navigator.userAgent
            link.href = convertToHtml(item.lurlAdr1Con)
            link.target = '_blank'
            link.rel = 'noopener noreferrer'
            if (/iP/.test(device)) {
                link.href = convertToHtml(item.lurlAdr2Con)
            }
        }
        return link
    }

    const slideItems = React.useMemo(() => {
        let _slides = []
        let toDay = getLocalDateTime('YYYYMMDDhhmmss')
        items.forEach((item, index) => {
            if (
                Number(item.expuSttgTs) <= Number(toDay) &&
                Number(item.expuFnshTs) >= Number(toDay)
            ) {
                //링크 형식을 가져온다.
                const extLink = parseLink(item)

                let extChild = null
                //DOM구조가 달라 두개로 분리시킴
                if (item.bnnrExpuTcd === '1') {
                    //문구가 추가된 배너인지 본다.
                    extChild = (
                        <div className="slick-content-box">
                            <div className="slick-txgroup">
                                <div className="main">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                replaceTextToHtmlTag(
                                                    item.bnnrTtlNm
                                                )
                                            ),
                                        }}
                                    ></div>
                                </div>
                                <div className="sub">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                replaceTextToHtmlTag(
                                                    item.bnnrDescCon
                                                )
                                            ),
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <img
                                src={item.imgUrlAdr}
                                alt={item.imgNm}
                                className="slick-img"
                            />
                        </div>
                    )
                } else {
                    //통이미지 배너
                    extChild = <img src={item.imgUrlAdr} alt={item.imgNm} />
                }
                _slides.push(
                    <div
                        className="slick-content"
                        key={`slick-content${index}`}
                    >
                        <a
                            {...extLink}
                            className="slick-link"
                            style={
                                item.bnnrClobNm.length > 1
                                    ? { background: item.bnnrClobNm }
                                    : null
                            }
                            key={`banner${index}`}
                        >
                            <span className="blind">
                                이벤트 베너 설명 입니다.
                            </span>
                            {extChild}
                        </a>
                    </div>
                )
            }
        })

        return _slides
    }, [items])

    return (
        <div className="baner-event">
            <Slider
                ref={sliderRef}
                swipe={slideItems.length > 1 ? true : false}
                dots={false}
                infinite={true}
                speed={500}
                autoplay={true}
                autoplaySpeed={3000}
                arrows={true}
                afterChange={(index: number) => setCurrentSlide(index)}
                className="mx-out"
            >
                {slideItems}
            </Slider>
            {slideItems.length > 1 && (
                <div className="slick-fraction">
                    <span className="page">
                        <em>{(currentSlide % slideItems.length) + 1}</em>/
                        <span>{slideItems.length}</span>
                    </span>
                    <Button className="handle" onClick={toggleplay}>
                        {isPlaying ? (
                            <Icon name="stop" text="재생" />
                        ) : (
                            <Icon name="play" text="정지" />
                        )}
                    </Button>
                </div>
            )}
        </div>
    )
}

export default Banner
